import React, { useEffect, useState } from "react";

import { fmtQty } from "@/lib/scan-ui/status";

/**
 * Число в степпере «− / +» — РЕДАКТИРУЕМОЕ: тап выделяет всё, набрал 14000 —
 * готово. Боевой случай 12.08.2026: 14000 флаконов вносили нажатиями «+».
 * Глобальный перехват скана на текстовых полях приостанавливается сам
 * (`use-scan-capture.isTextEntry`), так что ввод с клавиатуры безопасен.
 *
 * Пустое поле и мусор НЕ дёргают onChange (черновик остаётся прежним),
 * blur возвращает в поле актуальное значение.
 *
 * `integer` — только целые не меньше `min` (цифровая клавиатура,
 * `inputMode="numeric"`); без него — прежнее поведение: дробные ≥ 0.
 * `onEnter` — Enter на клавиатуре (например, «сохранить»): вызывается ПОСЛЕ
 * последнего onChange, так что у вызывающего уже актуальное значение.
 */
export function QtyInput({
  value,
  onChange,
  integer = false,
  min = 0,
  onEnter,
}: {
  value: number;
  onChange: (value: number) => void;
  integer?: boolean;
  min?: number;
  onEnter?: () => void;
}): React.ReactElement {
  const [text, setText] = useState(() => fmtQty(value));
  useEffect(() => setText(fmtQty(value)), [value]);
  return (
    <input
      type="text"
      inputMode={integer ? "numeric" : "decimal"}
      value={text}
      onFocus={(e) => e.target.select()}
      onChange={(e) => {
        const t = e.target.value.replace(",", ".");
        setText(t);
        if (integer && !/^\d+$/.test(t)) return;
        const n = Number(t);
        if (t !== "" && Number.isFinite(n) && n >= min) onChange(n);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && onEnter) {
          e.preventDefault();
          onEnter();
        }
      }}
      onBlur={() => setText(fmtQty(value))}
      className="w-24 rounded-lg border py-1 text-center font-mono text-[26px] font-bold tabular-nums"
      aria-label="Количество"
    />
  );
}
